import * as yup from 'yup';
export const validationSchema = (cmsData?: any) =>
  yup.object({
    firstName: yup.string().matches(cmsData?.firstNameRegex),
    lastName: yup.string().matches(cmsData?.lastNameRegex),
    codeFiscal: yup
          .string()
          .test(
            'fiscalCode',
            'Inserire un codice fiscale valido',
            (value) =>
              !!(
                value?.length === 16 &&
                value?.match(/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/)
              )
          ).matches(cmsData?.codeFiscalRegex),
    codePromo: yup.string().matches(cmsData?.codePromoRegex),
  });

